import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Prompt } from "react-router-dom";
import {
  fetchBudget,
  updateRoleDailyRate,
  updateCrewRequired,
  updateCrewDays,
  updateEquipmentRequired,
  updateEquipmentDays,
  updateEquipmentDailyRate,
  updateDays,
  updateBudget,
  updateCharacterDailyRate,
  updatePropBuget,
  updatePropDays,
  updateSetDressingBuget,
  updateSetDressingDays,
  updateCostumeBuget,
  updateCostumeDays,
  updateMakeupBuget,
  updateMakeupDays,
  updateBackgroundCharacterBuget,
  updateBackgroundCharacterDays,
  updateSceneSettingDailyRate,
  updateSceneSettingDays,
  onChangeCateringBuget,
  onChangeCateringDays,
  showHideCharacters,
  showHideSceneSettings,
  showHideCrew,
  showHideEquipment,
  showHideProps,
  showHideSetDressings,
  showHideCostumes,
  showHideMakeups,
  showHideCatering,
  showHideBackgroundCharacters,
  showHideVisualEffects,
  updateContingencyPercentage,
  downloadBudget,
  clearPdf,
  updateVisualEffectBuget,
  showHideSoundEffects,
  updateSoundEffectBuget,
  showHideMiscellaneous,
  addFixedMiscellaneousItem,
  addDailyMiscellaneousItem,
  onChangeMiscellaneousItemBuget,
  onChangeMiscellaneousItemName,
  onChangeMiscellaneousItemDays
} from "./ducks/actions";
import Budget from "./budget";
import Errors from "../../shared/errors";
import Loader from "../../shared/loader";
import Onboarding from '../../shared/onboarding/onboarding';
import ScrollIntoView from "../../shared/scroll-into-view/scroll-into-view";

const EditContainer = (props) => {
  const filmId = props.match.params.id;
  const {
    fetchBudget,
    updateRoleDailyRate,
    updateCrewRequired,
    updateCrewDays,
    updateEquipmentRequired,
    updateEquipmentDays,
    updateEquipmentDailyRate,
    updateDays,
    updateBudget,
    updateCharacterDailyRate,
    updatePropBuget,
    updatePropDays,
    updateSetDressingBuget,
    updateSetDressingDays,
    updateCostumeBuget,
    updateCostumeDays,
    updateBackgroundCharacterBuget,
    updateBackgroundCharacterDays,
    updateMakeupBuget,
    updateMakeupDays,
    updateSceneSettingDailyRate,
    updateSceneSettingDays,
    onChangeCateringBuget,
    onChangeCateringDays,
    budget,
    loading,
    errors,
    showHideCharacters,
    showHideSceneSettings,
    showHideCrew,
    showHideEquipment,
    showHideProps,
    showHideSetDressings,
    showHideCostumes,
    showHideMakeups,
    showHideBackgroundCharacters,
    showHideCatering,
    showHideVisualEffects,
    charactersVisible,
    sceneSettingsVisible,
    crewVisible,
    equipmentVisible,
    propsVisible,
    setDressingsVisible,
    costumesVisible,
    makeupsVisible,
    backgroundCharactersVisible,
    visualEffectsVisible,
    soundEffectsVisible,
    cateringVisible,
    updateContingencyPercentage,
    clearPdf,
    progress,
    download,
    downloadBudget,
    onboardingStepsWithShootingDays,
    onboardingStepsWithoutShootingDays,
    saved,
    saving,
    updateVisualEffectBuget,
    updateSoundEffectBuget,
    showHideSoundEffects,
    soundEffectsEnabled,
    showHideMiscellaneous,
    miscellaneousVisible,
    addFixedMiscellaneousItem,
    addDailyMiscellaneousItem,
    onChangeMiscellaneousItemBuget,
    onChangeMiscellaneousItemName,
    onChangeMiscellaneousItemDays
  } = props;

  useEffect(() => {
    fetchBudget(filmId);
  }, []);

  const onUpdateBudget = (budget) => {
    updateBudget(
      filmId,
      budget,
      charactersVisible,
      backgroundCharactersVisible,
      sceneSettingsVisible,
      crewVisible,
      propsVisible,
      setDressingsVisible,
      costumesVisible,
      makeupsVisible,
      cateringVisible,
      equipmentVisible,
      visualEffectsVisible,
      soundEffectsVisible,
      miscellaneousVisible
    );
  };

  const formatCsvValue = (value) => {
    if (value === null || value === undefined) {
      return "";
    }
    const text = String(value);
    if (/[",\n]/.test(text)) {
      return `"${text.replace(/"/g, '""')}"`;
    }
    return text;
  };

  const sanitizeFileName = (value) => {
    if (!value) {
      return "";
    }
    return String(value).replace(/[\\/:*?"<>|]+/g, "").trim();
  };

  const buildBudgetCsvRows = (budget) => {
    const rows: Array<Array<string | number>> = [
      ["Category", "Department", "Role", "Item", "Quantity", "Days", "Daily Rate", "Total"]
    ];

    const addRow = (category, name, days, dailyRate, total, options: any = {}) => {
      const hasTotal = total !== null && total !== undefined;
      if (!hasTotal) {
        return;
      }
      rows.push([
        category,
        options.department ?? "",
        options.role ?? "",
        name ?? "",
        options.quantity ?? "",
        days ?? "",
        dailyRate ?? "",
        total ?? ""
      ]);
    };

    (budget?.characters || []).forEach((item) => {
      addRow("Characters", item.name, item.days, item.dailyBudget, item.total, { quantity: item.quantity });
    });

    (budget?.backgroundCharacters || []).forEach((item) => {
      addRow("Background Characters", item.name, item.days, item.dailyBudget, item.total, { quantity: item.quantity });
    });

    (budget?.sceneSettings || []).forEach((item) => {
      addRow("Scene Settings", item.name, item.days, item.dailyBudget, item.total, { quantity: item.quantity });
    });

    (budget?.departments || []).forEach((department) => {
      (department.crew || []).forEach((crew) => {
        if (!crew.required) {
          return;
        }
        addRow("Crew", "", crew.days, crew.dailyRate, crew.total, { department: department.name, role: crew.name, quantity: crew.quantity });
      });
    });

    (budget?.props || []).forEach((item) => {
      addRow("Props", item.name, item.hire ? item.days : "", item.hire ? item.dailyBudget : item.budget, item.total, { quantity: item.quantity });
    });

    (budget?.setDressings || []).forEach((item) => {
      addRow("Set Dressings", item.name, item.hire ? item.days : "", item.hire ? item.dailyBudget : item.budget, item.total, { quantity: item.quantity });
    });

    (budget?.costumes || []).forEach((item) => {
      addRow("Costumes", item.name, item.hire ? item.days : "", item.hire ? item.dailyBudget : item.budget, item.total, { quantity: item.quantity });
    });

    (budget?.makeups || []).forEach((item) => {
      addRow("Makeups", item.name, item.days, item.dailyBudget, item.total, { quantity: item.quantity });
    });

    (budget?.equipments || []).forEach((category) => {
      (category.equipment || []).forEach((equipment) => {
        if (!equipment.required) {
          return;
        }
        const equipmentRate = equipment.buyBudget ?? equipment.dailyRate;
        addRow("Equipment", equipment.name, equipment.days, equipmentRate, equipment.total, { quantity: equipment.quantity, department: category.name });
      });
    });

    (budget?.visualEffects || []).forEach((item) => {
      const rate = item.hire ? item.dailyBudget : item.budget;
      addRow("Visual Effects", item.name, item.days ?? "", rate, item.total, { quantity: item.quantity });
    });

    (budget?.soundEffects || []).forEach((item) => {
      const rate = item.hire ? item.dailyBudget : item.budget;
      addRow("Sound Effects", item.name, item.days ?? "", rate, item.total, { quantity: item.quantity });
    });

    (budget?.miscellaneous || []).forEach((item) => {
      const rate = item.hire ? item.dailyBudget : item.budget ?? item.dailyBudget;
      addRow("Miscellaneous", item.name, item.days ?? "", rate, item.total, { quantity: item.quantity });
    });

    if (budget?.catering) {
      addRow("Catering", "Catering", "", budget.catering.budget, budget.catering.total, { quantity: budget.catering.mealDays ?? budget.catering.quantity });
    }

    return rows;
  };

  const onDownloadCsv = () => {
    if (!budget) {
      return;
    }

    const rows = buildBudgetCsvRows(budget);
    const csvContent = rows
      .map((row) => row.map(formatCsvValue).join(","))
      .join("\r\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    const filmTitle = sanitizeFileName(budget?.filmName || budget?.name || "film");
    link.download = `${filmTitle || "film"} Budget.csv`;
    link.click();
    setTimeout(() => window.URL.revokeObjectURL(url), 100);
  };

  function renderFilm(budget) {
    return (
      <ScrollIntoView
        className="blade-content wide"
        path="/films/:filmId/budget"
        loading={loading}>
        <h2 className="menu-label">Film Budget</h2>
        {errors && <Errors errors={errors} />}
        <Prompt when={!saved} message="" />
        {(saving) && <Loader />}
        <Budget
          filmId={filmId}
          budget={budget}
          updateRoleDailyRate={updateRoleDailyRate}
          updateCrewRequired={updateCrewRequired}
          updateDays={updateDays}
          updateBudget={onUpdateBudget}
          updateCrewDays={updateCrewDays}
          updateEquipmentRequired={updateEquipmentRequired}
          updateEquipmentDays={updateEquipmentDays}
          updateEquipmentDailyRate={updateEquipmentDailyRate}
          updateCharacterDailyRate={updateCharacterDailyRate}
          updatePropBuget={updatePropBuget}
          updatePropDays={updatePropDays}
          updateSetDressingBuget={updateSetDressingBuget}
          updateSetDressingDays={updateSetDressingDays}
          updateCostumeBuget={updateCostumeBuget}
          updateCostumeDays={updateCostumeDays}
          updateBackgroundCharacterBuget={updateBackgroundCharacterBuget}
          updateBackgroundCharacterDays={updateBackgroundCharacterDays}
          updateMakeupBuget={updateMakeupBuget}
          updateMakeupDays={updateMakeupDays}
          updateSceneSettingDailyRate={updateSceneSettingDailyRate}
          updateSceneSettingDays={updateSceneSettingDays}
          onChangeCateringBuget={onChangeCateringBuget}
          onChangeCateringDays={onChangeCateringDays}
          showHideCharacters={showHideCharacters}
          showHideBackgroundCharacters={showHideBackgroundCharacters}
          showHideSceneSettings={showHideSceneSettings}
          showHideCrew={showHideCrew}
          showHideEquipment={showHideEquipment}
          showHideProps={showHideProps}
          showHideSetDressings={showHideSetDressings}
          showHideCostumes={showHideCostumes}
          showHideMakeups={showHideMakeups}
          showHideCatering={showHideCatering}
          showHideVisualEffects={showHideVisualEffects}
          charactersVisible={charactersVisible}
          backgroundCharactersVisible={backgroundCharactersVisible}
          sceneSettingsVisible={sceneSettingsVisible}
          crewVisible={crewVisible}
          equipmentVisible={equipmentVisible}
          propsVisible={propsVisible}
          costumesVisible={costumesVisible}
          makeupsVisible={makeupsVisible}
          setDressingsVisible={setDressingsVisible}
          cateringVisible={cateringVisible}
          visualEffectsVisible={visualEffectsVisible}
          updateContingencyPercentage={updateContingencyPercentage}
          clearPdf={clearPdf}
          progress={progress}
          download={download}
          downloadBudget={downloadBudget}
          saved={saved}
          saving={saving}
          updateVisualEffectBuget={updateVisualEffectBuget}
          soundEffectsVisible={soundEffectsVisible}
          updateSoundEffectBuget={updateSoundEffectBuget}
          showHideSoundEffects={showHideSoundEffects}
          soundEffectsEnabled={soundEffectsEnabled}
          miscellaneousVisible={miscellaneousVisible}
          showHideMiscellaneous={showHideMiscellaneous}
          onAddFixedMiscellaneousItem={addFixedMiscellaneousItem}
          onAddDailyMiscellaneousItem={addDailyMiscellaneousItem}
          onChangeMiscellaneousItemBuget={onChangeMiscellaneousItemBuget}
          onChangeMiscellaneousItemName={onChangeMiscellaneousItemName}
          onChangeMiscellaneousItemDays={onChangeMiscellaneousItemDays}
          downloadCsv={onDownloadCsv}
        ></Budget>
        <Onboarding onboardingSteps={budget.hasShootingDays ? onboardingStepsWithShootingDays : onboardingStepsWithoutShootingDays} section="Budget" />
      </ScrollIntoView>
    );
  }

  return (
    <>
      {(loading || !budget) && <Loader />}
      {!loading && budget && renderFilm(budget)}
    </>
  );
};

function mapStateToProps(state) {
  const { budgetState } = state;
  return {
    errors: budgetState.errors,
    loading: budgetState.loading,
    budget: budgetState.budget,
    charactersVisible: budgetState.charactersVisible,
    sceneSettingsVisible: budgetState.sceneSettingsVisible,
    crewVisible: budgetState.crewVisible,
    equipmentVisible: budgetState.equipmentVisible,
    propsVisible: budgetState.propsVisible,
    costumesVisible: budgetState.costumesVisible,
    makeupsVisible: budgetState.makeupsVisible,
    setDressingsVisible: budgetState.setDressingsVisible,
    backgroundCharactersVisible: budgetState.backgroundCharactersVisible,
    cateringVisible: budgetState.cateringVisible,
    visualEffectsVisible: budgetState.visualEffectsVisible,
    soundEffectsVisible: budgetState.soundEffectsVisible,
    miscellaneousVisible: budgetState.miscellaneousVisible,
    download: budgetState.download,
    progress: budgetState.progress,
    onboardingStepsWithShootingDays: budgetState.onboardingStepsWithShootingDays,
    onboardingStepsWithoutShootingDays: budgetState.onboardingStepsWithoutShootingDays,
    saved: budgetState.saved,
    saving: budgetState.saving,
    soundEffectsEnabled: budgetState.soundEffectsEnabled,
  };
}

export default connect(mapStateToProps, {
  fetchBudget,
  updateRoleDailyRate,
  updateCrewRequired,
  updateCrewDays,
  updateEquipmentRequired,
  updateEquipmentDays,
  updateEquipmentDailyRate,
  updateDays,
  updateBudget,
  updateCharacterDailyRate,
  updatePropBuget,
  updatePropDays,
  updateSetDressingBuget,
  updateSetDressingDays,
  updateBackgroundCharacterBuget,
  updateBackgroundCharacterDays,
  updateCostumeBuget,
  updateCostumeDays,
  updateMakeupBuget,
  updateMakeupDays,
  updateSceneSettingDailyRate,
  updateSceneSettingDays,
  onChangeCateringBuget,
  onChangeCateringDays,
  showHideCharacters,
  showHideSceneSettings,
  showHideCrew,
  showHideEquipment,
  showHideProps,
  showHideCostumes,
  showHideMakeups,
  showHideBackgroundCharacters,
  showHideSetDressings,
  showHideCatering,
  showHideVisualEffects,
  showHideSoundEffects,
  updateContingencyPercentage,
  downloadBudget,
  clearPdf,
  updateVisualEffectBuget,
  updateSoundEffectBuget,
  showHideMiscellaneous,
  addFixedMiscellaneousItem,
  addDailyMiscellaneousItem,
  onChangeMiscellaneousItemBuget,
  onChangeMiscellaneousItemName,
  onChangeMiscellaneousItemDays
})(EditContainer);
